module.exports = __webpack_public_path__ + "static/img/bag.0d889098.png";